export default __webpack_public_path__ + "6f863fcb56d8b6cb186730f36584df65.webp";